import React from 'react'
import {
  Button,
  Form,
  Input,
  Select,
  Modal,
  Col,
  Row,
  Table,
  Space, message, Pagination, ConfigProvider, Upload, Tag
} from 'antd'
import './index.less'
import {
  API_HOST_WEBSOCKET,
  API_HEADSHOP_EXCEL_UPLOAD
} from "../../constants";
import {createWebSocket, closeWebSocket, reconnect} from "../../utils/websocket";
import zhCN from "antd/es/locale/zh_CN";
import {UploadOutlined} from "@ant-design/icons";

import {removeToken} from '../../utils/cookie'
import {
  getTemplateList,
  getTemplateInfo,
  getShopListShop,
  getTemplateSave,
  getTemplateChangeStatus,
  getTemplateSaveShop,
  getTemplateDeleteShop,
  getTemplatePassCheck,
  getTemplatePassUpdate,
  getShopCheck
} from '../../constants/api'

const { Search } = Input;
const { CheckableTag } = Tag;
const FormItem = Form.Item;
const Option = Select.Option;

export default class HeadShop extends React.Component {

  constructor() {
    super();
    this.connectWebSocket();
  }

  state = {
    selectedRowKeys: [], // Check here to configure the default column
    loading: false,

    templateId: 1,//模板ID
    shopId: 0,//门店ID

    confirmLoading: false,
    visible: false,//新建总店弹窗显示隐藏
    inputName: '',//名称
    inputDesc: '',//描述
    shop: [],//下拉多选门店数据
    shopDefaultName: '',
    shopSelectIds: [],//选中的店ID

    value: 2,
    timeInterval: 1,

    templateIdOption: 0,//临时操作ID
    onDeleteVisible: false, //删除模态框

    headShops: [],//总店列表
    current: 1,
    pageSize: 10,
    total: 0,
    platformType: null, //总店类型，
    modalType: "新建总店",
    page: 0, //搜索框的分页
    showModalAdd: false, //增加分店
    showModalDel: false, //删除分店
    tempPlatformType: 0,  //存储平台Id
    checkPwdModal: false, //切换总店输入密码的modal
    tempTemplateName: '',  //存储总店名
    pwd: "",  //总店验证密码
    editPwdModal: "", //修改密码
    inputShopId: '',//检查分店ID输入
    inTemplateName: '',//所属总店

    fileList: [],//上传excel返回结果

    selectedTag: '全部',//类型value
    selectedType: 0,//4饿了么5饿百
    searchName: '',//搜索
  }

  connectWebSocket() {
    const _this = this;
    let websocket, lockReconnect = false;
    this.createWebSocket = (url) => {
      websocket = new WebSocket(url);
      websocket.onopen = function () {
        heartCheck.reset().start();
      }
      websocket.onerror = function () {
        reconnect(url);
      };
      websocket.onclose = function (e) {
        console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
      }
      websocket.onmessage = function (event) {
        if (event.data === '连接成功') {
          lockReconnect = true;
          _this.setState({
            visible: false,
            confirmLoading: false,
            showModalAdd: false,
          }, () => {
            _this.searchHeadShop(1, _this.state.pageSize, 0, '')
          })
        } else if (event.data == 'HeartBeat') {

        } else {
          let data = JSON.parse(event.data)
          lockReconnect = true;
          //event 为服务端传输的消息，在这里可以处理
          if (data.dataHandleStatus === 1) {
            message.success('数据同步完成')
            _this.setState({
              visible: false,
              confirmLoading: false,
              showModalAdd: false,
            }, () => {
              _this.searchHeadShop(1, _this.state.pageSize, 0, '')
            })
          }
        }
      }
    }
    let reconnect = (url) => {
      if (lockReconnect) return;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        this.createWebSocket(url);
        lockReconnect = false;
      }, 4000);
    }
    let heartCheck = {
      timeout: 60000, //60秒
      timeoutObj: null,
      reset: function () {
        clearInterval(this.timeoutObj);
        return this;
      },
      start: function () {
        this.timeoutObj = setInterval(function () {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          websocket.send("HeartBeat");
        }, this.timeout)
      }
    }
    //关闭连接
    this.closeWebSocket = () => {
      websocket && websocket.close();
    }
  }

  changeProductShelf(shelf, xmCategoryId, productId) {
    console.log(shelf)
    console.log(xmCategoryId)
    console.log(productId)
  }

  componentDidMount() {
    this.searchHeadShop(1, 10, 0, '')
  }

  searchShop() {
    const _this = this;
    if (!_this.state.platformType) {
      message.info('请先选择总店类型', 1, () => {
        return false
      })
    }
    const {page} = this.state
    getShopListShop({
      pageIndex: page,
      pageSize: 20,
      platformType: _this.state.platformType,
      searchName: '',
      sortName: "",
      sortType: "descending",
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            shop: data.data.records,
            shopDefaultName: data.data.records[0].shopName
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  //下拉多选门店
  changeShop = value => {
    console.log(value)
    this.setState({shopSelectIds: value})
  };

  searchHeadShop(current, size, type, name) {
    const _this = this;
    getTemplateList({
      pageIndex: current,
      pageSize: size,
      sortName: "",
      sortType: "descending",
      templateName: name,
      templateType: type
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            headShops: data.data.records,
            current: data.data.current,
            total: data.data.total,
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  start = () => {
    this.setState({loading: true});
    // ajax request after empty completing
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        loading: false,
      });
    }, 1000);
  };

  onSelectChange = selectedRowKeys => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({selectedRowKeys});
  };

  //编辑查询信息
  fetchHeadshopInfo(templateId) {
    const _this = this;
    getTemplateInfo({
      templateId: templateId,
      id: templateId,
      shopId: 0,
      platformType: _this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let shops = data.data.shops;
          let shop_Ids = []
          shops.map((shop, index) => {
            shop_Ids.push(shop.shopId)
          })

          _this.setState({
            inputName: data.data.templateName,
            inputDesc: data.data.description,
            shop: data.data.shops,
            shopDefaultName: data.data.shops[0].shopName,
            platformType: data.data.platformType,
            shopSelectIds: shop_Ids
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  useWebSocketSync(key) {
    let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
    this.createWebSocket(url)
    //在组件卸载的时候，关闭连接
    return () => {
      this.closeWebSocket();
    }
  }

  //展示新建总店弹窗
  showModal = (type, templateId, platformType) => {
    if (type === 0) {
      //新建总店
      this.setState({
        visible: true,
        inputName: '',
        inputDesc: '',
        shopSelectIds: [],
        templateIdOption: 0,
        platformType: null,
        modalType: "新建总店",
        shop: [],
      });
    } else {
      //编辑总店
      this.setState({
        visible: true,
        templateIdOption: templateId,
        modalType: "编辑总店",
        platformType: platformType
      }, () => {
        //查询店列表，提供下拉展示
        this.fetchHeadshopInfo(templateId);
      });
    }
  };
  changeInputName = e => {
    const {value} = e.target;
    this.setState({inputName: value})
  }
  changeInputDesc = e => {
    const {value} = e.target;
    this.setState({inputDesc: value})
  }
  //新建总店点击确定调用接口
  handleOk = (e) => {
    if (this.state.modalType == '新建总店') {
      if (this.state.addNewPwd !== this.state.addConfirmNewPwd) {
        return message.error("两次输入密码不一致,请重新输入", 1)
      }
    }
    this.setState({
      confirmLoading: true,
    });
    const _this = this;
    getTemplateSave({
      templateId: this.state.templateIdOption,
      templateName: this.state.inputName,
      description: this.state.inputDesc,
      platformType: _this.state.platformType,
      shops: this.state.modalType == '新建总店' ? this.state.shopSelectIds : [],
      pass: this.state.modalType == '新建总店'? this.state.addConfirmNewPwd : this.state.addNewPwd
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.dataHandleStatus === 0) {
            setTimeout(() => {
              message.success('正在同步数据,请耐心等待')
              _this.useWebSocketSync(data.data.messageKey)
            }, 1000);
          } else {
            _this.setState({
              visible: false,
              confirmLoading: false,
            }, () => {
              _this.searchHeadShop(1, _this.state.pageSize, 0, '')
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
          _this.setState({
            confirmLoading: false,
          });
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_TEMPLATE_SAVE, {
    //   templateId: this.state.templateIdOption,
    //   templateName: this.state.inputName,
    //   description: this.state.inputDesc,
    //   platformType: _this.state.platformType,
    //   shops: this.state.modalType == '新建总店' ? this.state.shopSelectIds : [],
    //   pass: this.state.modalType == '新建总店'? this.state.addConfirmNewPwd : this.state.addNewPwd
    //
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       if (data.data.dataHandleStatus === 0) {
    //         setTimeout(() => {
    //           message.success('正在同步数据,请耐心等待')
    //           _this.useWebSocketSync(data.data.messageKey)
    //         }, 1000);
    //       } else {
    //         _this.setState({
    //           visible: false,
    //           confirmLoading: false,
    //         }, () => {
    //           _this.searchHeadShop(1, _this.state.pageSize, 0, '')
    //         })
    //       }
    //
    //     } else {
    //       //建立websocket
    //       message.error(data.msg, 1)
    //       _this.setState({
    //         confirmLoading: false,
    //       });
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };
  //新建总店点击取消
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  onChange = e => {
    console.log('radio checked', e.target.value);
    this.setState({
      value: e.target.value,
    });
  };
  onChangeTimeinterval = e => {
    console.log('radio checked', e.target.value);
    this.setState({
      timeInterval: e.target.value,
    });
  };

  //确认删除
  onHandleOk = (type) => {
    console.log(type)
    this.deleteHeadShop();
  }
  onHandleCancel = (type) => {
    this.setState({
      onDeleteVisible: false
    })
  }

  deleteHeadShop = () => {
    getTemplateChangeStatus({
      dataStatus: -100,
      id: this.state.templateIdOption,
      shopId: 0,
      templateId: this.state.templateIdOption
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            onDeleteVisible: false
          }, () => {
            message.success('删除成功')
            this.searchHeadShop(1, this.state.pageSize, 0, '');
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          // message.error(data.msg)
          this.setState({
            onDeleteVisible: false
          }, () => {
            message.error('删除失败')
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axiosD.post(API_TEMPLATE_CHANGE_STATUS, {
    //   dataStatus: -100,
    //   id: this.state.templateIdOption,
    //   shopId: 0,
    //   templateId: this.state.templateIdOption
    // }).then((res) => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data
    //     if (data.code === 0) {
    //       this.setState({
    //         onDeleteVisible: false
    //       }, () => {
    //         message.success('删除成功')
    //         this.searchHeadShop(1, this.state.pageSize, 0, '');
    //       })
    //     } else {
    //       this.setState({
    //         onDeleteVisible: false
    //       }, () => {
    //         message.error('删除失败')
    //       })
    //     }
    //   }
    // })
  }

  //删除弹窗
  onShowModal = (templateId) => {
    this.setState({
      onDeleteVisible: true,
      templateIdOption: templateId,
    })
  }

  /**
   * @Description:
   * @Author Jiang
   * @Date 2020/8/2 15:28
   */
  checkHeadShop = (templateId, templateName, platformType) => {
    console.log(platformType)
    const _this = this;
    let storageOld = window.localStorage;
    let templateIdOld = storageOld.getItem('templateId');
    if (templateIdOld == templateId) {
      //不操作
    } else {
      //断开重连
      closeWebSocket();
      setTimeout(function () {
        createWebSocket(_this.props.history, "wss://" + API_HOST_WEBSOCKET + "/websocket/data/" + templateId);
      }, 2000);
    }

    //本地存储总店
    if (!window.localStorage) {
      alert('浏览器不支持localstorage');
      return false;
    } else {
      var storage = window.localStorage;
      storage.setItem('templateId', templateId);
      storage.setItem('templateName', templateName);
      storage.setItem('platformType', platformType)
      storage.setItem('shopId', 0);
      if (storage.getItem('templateId')) {
        message.success('切换总店成功', 1, () => window.location.reload())
        // message.success('切换总店成功', 1, () => _this.props.history.go(0))
        // message.success('切换总店成功', 1, () => window.location=window.location)
        // message.success('切换总店成功', 1, () => window.location.replace(window.location))
        // message.success('切换总店成功', 1, () => window.location.assign(window.location))
      }
    }
  }

  changeShopType = (value) => {
    this.setState({
      platformType: value
    }/*, () => this.searchShop()*/)
  }

  handlePopupScroll = e => {
    /*  const {page, shop} = this.state;
      e.persist();
      const {target} = e;
      console.log('____________________')
      console.log(target)
      const st = target.scrollTop;
      console.log('+++++++++++++')
      console.log(st)
      if (st === 0 && this.pageSt) {
        target.scrollTop = this.pageSt;
      }
      if (
        st + target.offsetHeight + 2 >= target.scrollHeight &&
        this.list.length < showArr.length
      ) {
        this.setState({page: page + 1});
        this.pageSt = st;
      } else {
        this.pageSt = 0;
      }*/
  };

  getShop = (filterWord, platformType) => {
    const _this = this
    getShopListShop({
      pageIndex: 0,
      pageSize: 0,
      platformType: platformType,
      searchContent: filterWord,
      sortName: "",
      sortType: "descending",
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            shop: data.data.records,
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  onSearch = (value) => {
    value = value || ''
    const filterWord = value.trim().toLowerCase()
    if (!this.state.platformType) {
      return message.error("请先选择总店类型", 1)
    }
    this.getShop(filterWord, this.state.platformType)

  }

  //展示新增分店店弹窗
  showModalAdd = (templateId, tempPlatformType) => {
    this.setState({
      showModalAdd: true,
      tempPlatformType: tempPlatformType,
      templateIdOption: templateId,
    });
  };


  onSearchAdd = (value) => {
    value = value || ''
    const filterWord = value.trim().toLowerCase()
    console.log(filterWord)
    this.getShop(filterWord, this.state.tempPlatformType)
  }


  handleAddOk = (e) => {
    this.setState({
      confirmLoading: true,
      fileList: []
    });
    const _this = this;
    getTemplateSaveShop({
      templateId: this.state.templateIdOption,
      platformType: this.state.tempPlatformType,
      shops: this.state.shopSelectIds
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.dataHandleStatus === 0) {
            setTimeout(() => {
              message.success('正在同步数据,请耐心等待')
              _this.useWebSocketSync(data.data.messageKey)
            }, 1000);
          } else {
            _this.setState({
              showModalAdd: false,
              confirmLoading: false,
            }, () => {
              _this.searchHeadShop(1, _this.state.pageSize, 0, '')
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
          _this.setState({
            confirmLoading: false,
          });
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_TEMPLATE_SAVE_SHOP, {
    //   templateId: this.state.templateIdOption,
    //   platformType: this.state.tempPlatformType,
    //   shops: this.state.shopSelectIds
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log('新增分店');
    //     console.log(data);
    //     if (data.code === 0) {
    //       if (data.data.dataHandleStatus === 0) {
    //         setTimeout(() => {
    //           message.success('正在同步数据,请耐心等待')
    //           _this.useWebSocketSync(data.data.messageKey)
    //         }, 1000);
    //       } else {
    //         _this.setState({
    //           showModalAdd: false,
    //           confirmLoading: false,
    //         }, () => {
    //           _this.searchHeadShop(1, _this.state.pageSize, 0, '')
    //         })
    //       }
    //
    //     } else {
    //       //建立websocket
    //       message.error(data.msg, 1)
    //       _this.setState({
    //         confirmLoading: false,
    //       });
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };
  handleAddCancel = e => {
    this.setState({
      showModalAdd: false,
    });
  };

  //展示删除分店弹窗
  showModalDel = (templateId, tempPlatformType) => {
    this.setState({
      showModalDel: true,
      tempPlatformType: tempPlatformType,
      templateIdOption: templateId,
    }, () => {
      this.fetchDelshop(templateId, tempPlatformType)
    });
  };

  fetchDelshop(templateId, tempPlatformType) {
    const _this = this;
    getTemplateInfo({
      templateId: templateId,
      id: templateId,
      shopId: 0,
      platformType: tempPlatformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        console.log(data)
        if (data.code === 0) {
          _this.setState({
            inputName: data.data.templateName,
            inputDesc: data.data.description,
            shop: data.data.shops,
            shopDefaultName: data.data.shops[0].shopName,
            platformType: data.data.platformType,
            shopSelectIds: []
            // shopSelectIds: shop_Ids
          }, () => {
            /*_this.searchShop()*/
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  handleDelOk = (e) => {
    this.setState({
      confirmLoading: true,
    });
    const _this = this;
    getTemplateDeleteShop({
      templateId: this.state.templateIdOption,
      ids: this.state.shopSelectIds
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success(data.msg, 1)
          _this.setState({
            showModalDel: false,
            confirmLoading: false,
          }, () => {
            _this.searchHeadShop(1, _this.state.pageSize, 0, '')
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
          _this.setState({
            confirmLoading: false,
          });
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_TEMPLATE_DEL_SHOP, {
    //   templateId: this.state.templateIdOption,
    //   ids: this.state.shopSelectIds
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       message.success(data.msg, 1)
    //       _this.setState({
    //         showModalDel: false,
    //         confirmLoading: false,
    //       }, () => {
    //         _this.searchHeadShop(1, _this.state.pageSize, 0, '')
    //       })
    //
    //     } else {
    //       message.error(data.msg, 1)
    //       _this.setState({
    //         confirmLoading: false,
    //       });
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  };
  handleDelCancel = e => {
    this.setState({
      showModalDel: false,
    });
  };

  /**
   * @Description: 切换输入密码
   * @Author Jiang
   * @Date 2020/9/7 11:25
   */
  checkPassword = (templateId, templateName, platformType, typeStr) => {
    this.setState({
      checkPwdModal: true,
      templateIdOption: templateId,
      tempPlatformType: platformType,
      tempTemplateName: templateName,
      typeStr: typeStr
    })
  }

  /**
   * @Description: 确认切换
   * @Author Jiang
   * @Date 2020/9/7 11:34
   */
  oncheckPwdOk = () => {
    this.checkPwd();
  }

  /**
   * @Description: 验证密码
   * @Author Jiang
   * @Date 2020/9/7 11:50
   */
  checkPwd = () => {
    getTemplatePassCheck({
      id: this.state.templateIdOption,
      pass: this.state.pwd
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            checkPwdModal: false
          })
          if (this.state.typeStr === '切换总店') {
            this.checkHeadShop(this.state.templateIdOption, this.state.tempTemplateName, this.state.tempPlatformType)
          } else if (this.state.typeStr === '删除总店') {
            this.onShowModal(this.state.templateIdOption)
          } else if (this.state.typeStr === '新增分店') {
            this.showModalAdd(this.state.templateIdOption, this.state.tempPlatformType)
          } else if (this.state.typeStr === '删除分店') {
            this.showModalDel(this.state.templateIdOption, this.state.tempPlatformType)
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axiosD.post(API_GOODS_CHECK_PWD, {
    //   id: this.state.templateIdOption,
    //   pass: this.state.pwd
    // }).then((response) => {
    //   let data = response.data;
    //   console.log(data)
    //   if (data.code === 0) {
    //     // this.checkHeadShop(this.state.templateIdOption, this.state.tempTemplateName, this.state.tempPlatformType)
    //     this.setState({
    //       checkPwdModal: false
    //     })
    //     if (this.state.typeStr === '切换总店') {
    //       this.checkHeadShop(this.state.templateIdOption, this.state.tempTemplateName, this.state.tempPlatformType)
    //     } else if (this.state.typeStr === '删除总店') {
    //       this.onShowModal(this.state.templateIdOption)
    //     } else if (this.state.typeStr === '新增分店') {
    //       this.showModalAdd(this.state.templateIdOption, this.state.tempPlatformType)
    //     } else if (this.state.typeStr === '删除分店') {
    //       this.showModalDel(this.state.templateIdOption, this.state.tempPlatformType)
    //     }
    //   } else {
    //     message.error(data.msg)
    //   }
    // }).catch(function (error) {
    //   console.log(error);
    // });
  }

  /**
   * @Description: 取消切换
   * @Author Jiang
   * @Date 2020/9/7 11:35
   */
  oncheckPwdOkCancel = () => {
    this.setState({
      checkPwdModal: false
    })
  }


  /**
   * @Description: 密码输入框控制
   * @Author Jiang
   * @Date 2020/9/7 11:48
   */
  onchangePwd = (e) => {
    this.setState({
      pwd: e.target.value
    })
  }

  /**
   * @Description: 确认新密码
   * @Author Jiang
   * @Date 2020/9/7 14:52
   */
  confirmPwd = (e) => {

    this.setState({
      confirmNewPwd: e.target.value
    })
  }


  /**
   * @Description: 确认修改密码
   * @Author Jiang
   * @Date 2020/9/7 14:59
   */
  onConfirmPwdOk = () => {
    if (this.state.confirmNewPwd !== this.state.newPwd) {
      return message.error("两次输入密码不一致,请重新输入", 1)
    }
    getTemplatePassUpdate({
      id: this.state.templateIdOption,
      newPass: this.state.confirmNewPwd,
      oldPass: this.state.oldPwd
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            editPwdModal: false
          }, () => message.success("修改成功", 1))
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_SHOP_EDIT_PWD, {
    //   id: this.state.templateIdOption,
    //   newPass: this.state.confirmNewPwd,
    //   oldPass: this.state.oldPwd
    // }).then((response) => {
    //   let data = response.data;
    //   console.log(data)
    //   if (data.code === 0) {
    //     this.setState({
    //       editPwdModal: false
    //     }, () => message.success("修改成功", 1))
    //   } else {
    //     message.error(data.msg)
    //   }
    // }).catch(function (error) {
    //
    // });
  }

  /**
   * @Description: 取消修改密码
   * @Author Jiang
   * @Date 2020/9/7 14:59
   */
  onConfirmPwdOkCancel = () => {
    this.setState({
      editPwdModal: false
    })
  }


  /**
   * @Description: 修改密码的模态框
   * @Author Jiang
   * @Date 2020/9/7 15:02
   */
  showModalConfirm = (templateId, platformType) => {
    this.setState({
      editPwdModal: true,
      templateIdOption: templateId,
      tempPlatformType: platformType,
    })
  }


  changeInputId = e => {
    const {value} = e.target;
    this.setState({inputShopId: value})
  }

  checkShopById() {
    const _this = this;
    getShopCheck({
      id: this.state.inputShopId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({inTemplateName: data.data.templateName + '(ID:' + data.data.templateId + ')'})
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axiosD.post(API_TEMPLATE_SHOP_CHECK, {
    //   id: this.state.inputShopId,
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       _this.setState({inTemplateName: data.data.templateName + '(ID:' + data.data.templateId + ')'})
    //     }
    //     // _this.setState({
    //     //   inputName: data.data.templateName,
    //     //   inputDesc: data.data.description,
    //     //   shop: data.data.shops,
    //     //   shopDefaultName: data.data.shops[0].shopName,
    //     //   platformType: data.data.platformType,
    //     //   shopSelectIds: []
    //     //   // shopSelectIds: shop_Ids
    //     // }, () => {
    //     //   /*_this.searchShop()*/
    //     // })
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  onChangePage(page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({current: page}, () => {
      this.searchHeadShop(page, this.state.pageSize, this.state.selectedType, this.state.searchName)
    })
  }
  onChangePageSize(page, pageSize) {
    console.log(page)
    console.log(pageSize)
    this.setState({current: page, pageSize: pageSize}, () => {
      this.searchHeadShop(page, pageSize, this.state.selectedType, this.state.searchName)
    })
  }

  onExcelChange = ({fileList}) => {
    const _this = this;
    this.setState({fileList: fileList}, ()=>{
      let file = fileList[0];
      if (file && file.status == 'done') {
        console.log('--------------success-------------------')
        console.log(file)
        let res = file.response;
        if (res.code === 0) {
          if (res.data.shopData.length > 0) {
            let shop_Ids = []
            res.data.shopData.map((shop, index) => {
              shop_Ids.push(shop.shopId)
            })
            _this.setState({shop: res.data.shopData, shopSelectIds:shop_Ids})
            message.success('操作成功')
          }

          if (res.data.errorUrl != null) {
            if (res.data.errorUrl === '') {
            } else {
              window.location.href = res.data.errorUrl
            }
          }
        } else {
          message.error(res.msg)
          _this.setState({fileList: []})
        }
      }
    })
  }

  handleTagChange(tag, checked) {
    console.log(tag);
    console.log(checked);
    this.setState({selectedTag: tag})
    if (tag === '全部') {
      this.setState({selectedType: 0, current:1}, ()=>{
        this.searchHeadShop(1, 10, 0, '')
      })
    } else if (tag === '饿了么') {
      this.setState({selectedType: 4, current:1}, ()=>{
        this.searchHeadShop(1, 10, 4, '')
      })
    } else if (tag === '饿百') {
      this.setState({selectedType: 5, current:1}, ()=>{
        this.searchHeadShop(1, 10, 5, '')
      })
    }
  }

  onSearchDelShop = (value) => {
    this.fetchDelshop2(this.state.templateIdOption, this.state.tempPlatformType, value)
  }
  fetchDelshop2(templateId, tempPlatformType, value) {
    const _this = this;
    getTemplateInfo({
      templateId: templateId,
      id: templateId,
      shopId: 0,
      platformType: tempPlatformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        console.log(data)
        if (data.code === 0) {


          value = value || ''
          let v = value.trim()
          let shopList = []
          data.data.shops.map((item, index)=> {
            console.log('-----')
            console.log(v)
            if (v == item.shopId || item.shopName.includes(v)) {
              console.log('%%%' + item.shopId)
              shopList.push(item)
            }
          })
          _this.setState({
            shop: shopList,
            shopSelectIds: []
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  render() {
    const _this = this
    const columnsHeadShop = [
      {
        title: '总店名称',
        dataIndex: 'templateName',
        render: (text, record) => (
            <div className={record.platformType == 4 ? "shop-elm-color" : record.platformType == 5 ? "shop-ebai-color" : null}>{record.templateName}</div>
        ),
      },
      {
        title: '描述',
        dataIndex: 'description',
      },
      {
        title: '类型',
        dataIndex: 'platformType',
        render: (text, record) => (
          <div
            className={record.platformType == 4 ? "shop-elm-color" : record.platformType == 5 ? "shop-ebai-color" : null}>
            {record.platformType == 4 ? '饿了么' :
              record.platformType == 5 ? '饿百' :
                record.platformType == 3 ? '美团' : ''}
          </div>
        ),
      },
      {
        title: '添加时间',
        dataIndex: 'addTime',
      },
      {
        title: '操作',
        dataIndex: 'option',
        render: (text, record) => (
          <Space size="middle">
            <a
              onClick={this.checkPassword.bind(this, record.templateId, record.templateName, record.platformType, '切换总店')}>切换总店</a>
            <a onClick={this.showModal.bind(this, 1, record.templateId,  record.platformType)}>编辑</a>
            {/*<a style={{color: "#eb222a"}} onClick={_this.onShowModal.bind(this, record.templateId)}>删除</a>*/}
            {/*<a onClick={this.showModalAdd.bind(this, record.templateId, record.platformType)}>新增分店</a>*/}
            {/*<a style={{color: "#eb222a"}} onClick={this.showModalDel.bind(this, record.templateId, record.platformType)}>删除分店</a>*/}
            <a style={{color: "#eb222a"}} onClick={this.checkPassword.bind(this, record.templateId, record.templateName, record.platformType, '删除总店')}>删除</a>
            <a onClick={this.checkPassword.bind(this, record.templateId, record.templateName, record.platformType, '新增分店')}>新增分店</a>
            <a style={{color: "#eb222a"}} onClick={this.checkPassword.bind(this, record.templateId, record.templateName, record.platformType, '删除分店')}>删除分店</a>
            <a onClick={this.showModalConfirm.bind(this, record.templateId, record.platformType)}>修改密码</a>
          </Space>
        ),
      },
    ];
    let {loading, selectedRowKeys, headShops, shop, fileList} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const formItemLayout = {
      labelCol: {
        xs: 24,
        sm: 4
      },
      wrapperCol: {
        xs: 24,
        sm: 12
      }
    }
    const platformType = [
      /* {
         name: "美团",
         value: 3
       },*/ {
        name: "饿了么",
        value: 4
      }, {
        name: "饿百",
        value: 5
      },
    ]

    const tagsData = ['全部', '饿了么', '饿百'];

    return (
      <div style={{width: "100%"}}>
        <Row className="container">
          <Col span="24" className="headshop-right">
            <div className="headshop-top">
              <div className="headshop-top-left">
                <div className="headshop-top-left1">
                  <span>类型：</span>{tagsData.map(tag => (
                    <CheckableTag
                        style={{height: '30px', lineHeight: '30px'}}
                        key={tag}
                        checked={this.state.selectedTag === tag}
                        onChange={checked => this.handleTagChange(tag, checked)}
                    >
                      {tag}
                    </CheckableTag>
                  ))}
                </div>
                <Search placeholder="输入总店名称"
                        onSearch={value => {
                          console.log(value)
                          this.setState({
                            current: 1,
                            searchName: value
                          }, ()=>{
                            this.searchHeadShop(1, 10, this.state.selectedType, value)
                          })
                        }} enterButton />
              </div>
              <Button type="primary" shape="round" onClick={this.showModal.bind(this, 0)}>新建总店</Button>
              {/*<span style={{marginLeft: 8}}>{hasSelected ? `Selected ${selectedRowKeys.length} items` : ''}</span>*/}
            </div>
            <div style={{padding: '0 10px 0 10px'}}>
              <Table rowKey="templateId"
                  // rowSelection={rowSelection}
                     columns={columnsHeadShop}
                     pagination={false}
                     dataSource={headShops}/>
              <ConfigProvider locale={zhCN}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", padding: "0 20px 0 0"}}>
                  <Pagination style={{marginTop: 20}} showQuickJumper={true} showSizeChanger={true} onShowSizeChange={this.onChangePageSize.bind(this)}
                              current={this.state.current} pageSize={this.state.pageSize} total={this.state.total}
                              onChange={this.onChangePage.bind(this)}/>
                </div>
              </ConfigProvider>
            </div>
          </Col>
        </Row>

        <Modal
          title={this.state.modalType}
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          confirmLoading={this.state.confirmLoading}
          okText="确认"
          cancelText="取消"
        >
          <Form layout="horizontal">
            <Form.Item
              {...formItemLayout}
              label="总店名称"
              rules={[
                {
                  required: true,
                  message: '请输入总店名称',
                },
              ]}
            >
              <Input value={_this.state.inputName} onChange={this.changeInputName} placeholder="请输入总店名称"/>
            </Form.Item>
            {
              this.state.modalType === '新建总店' ?
                <Form.Item
                  {...formItemLayout}
                  label="总店类型"
                  rules={[
                    {
                      required: true,
                      message: '请选择总店类型',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    value={_this.state.platformType}
                    style={{width: 240}}
                    bordered={true}
                    optionFilterProp="children"
                    placeholder={"请选择总店类型"}

                    filterOption={(input, option) =>
                      // option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      // option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      option.props.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={this.changeShopType}>
                    {platformType && platformType.map((item, index) => {
                      return <Option key={index.toString()} value={item.value}>{item.name}</Option>
                    })}
                  </Select>
                </Form.Item>
                :
                null
            }
            <Form.Item {...formItemLayout} label="总店描述">
              <Input.TextArea value={_this.state.inputDesc} onChange={this.changeInputDesc} placeholder="请输入总店描述"/>
            </Form.Item>
            {
              this.state.modalType === '新建总店' ?
                <div>
                  <Form.Item {...formItemLayout} label="分店">
                    <Select
                      mode="multiple"
                      showSearch
                      value={_this.state.shopSelectIds}
                      style={{width: 240}}
                      bordered={true}
                      placeholder={'请选择分店'}
                      onPopupScroll={_this.handlePopupScroll}
                      onSearch={this.onSearch.bind(this)}
                      onChange={this.changeShop}
                      optionFilterProp="children"
                      filterOption={(input, option) =>{
                        return  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || (option.props.children !== '')}
                      }
                    >
                      {/*<Option value={0}>{'全部'}</Option>*/}
                      {this.state.shop && this.state.shop.map((item) => {
                        return <Option key={item.shopId} value={item.shopId}>{item.shopName}</Option>
                      })}
                    </Select>
                  </Form.Item>
                  <FormItem {...formItemLayout} label="密码">
                    <Input type={'password'} placeholder={'请输入密码'}
                           onChange={(e) => this.setState({addNewPwd: e.target.value})}/><br/>
                  </FormItem>
                  <FormItem {...formItemLayout} label="确认密码">
                    <Input type={'password'} placeholder={'请确认密码'}
                           onChange={(e) => this.setState({addConfirmNewPwd: e.target.value})}
                    />
                  </FormItem>
                </div>
                :
                  <div>
                    <FormItem {...formItemLayout} label="密码">
                      <Input type={'password'} placeholder={'请输入密码'}
                             onChange={(e) => this.setState({addNewPwd: e.target.value})}/><br/>
                    </FormItem>
                  </div>
            }
          </Form>
        </Modal>

        <Modal
          visible={this.state.onDeleteVisible}
          onOk={this.onHandleOk.bind(this, 'delete')}
          onCancel={this.onHandleCancel.bind(this, 'delete')}
          okText="确认"
          cancelText="取消"
        >
          确定将总店删除嘛？
        </Modal>

        <Modal
          title='新增分店'
          width={'40%'}
          visible={this.state.showModalAdd}
          onOk={this.handleAddOk}
          onCancel={this.handleAddCancel}
          confirmLoading={this.state.confirmLoading}
          okText="确认"
          cancelText="取消"
        >
          <Form layout="horizontal">
            <Form.Item {...formItemLayout} label="检查分店">
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <Input style={{width: '150px'}} value={this.state.inputShopId} onChange={this.changeInputId}
                       placeholder="请输入分店ID"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary"
                        onClick={this.checkShopById.bind(this)}>
                  检查
                </Button>
              </div>
              <div>
                所属总店：{this.state.inTemplateName === '' ? '无' : this.state.inTemplateName}
              </div>
              <div style={{display: 'flex', flexDirection: 'row',  alignItems: 'center', marginTop: '20px'}}>
                <Upload
                    name="file"
                    action={API_HEADSHOP_EXCEL_UPLOAD}
                    data={{templateId: this.state.templateIdOption}}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    fileList={fileList}
                    onChange={this.onExcelChange}
                >
                  {fileList && fileList.length >= 1 ? null :
                      <Button icon={<UploadOutlined />}>批量导入</Button>
                  }
                </Upload>
                <a style={{marginLeft: '20px'}} href={'http://eleshop.xunmengvip.com/template/批量新增门店模板.xlsx'}>下载模板</a>
              </div>
            </Form.Item>
            <Form.Item {...formItemLayout} label="分店">
              <Select
                mode="multiple"
                showSearch
                value={_this.state.shopSelectIds}
                style={{width: 240}}
                bordered={true}
                placeholder={'请选择分店'}
                onSearch={this.onSearchAdd.bind(this)}
                onChange={this.changeShop}
                // optionFilterProp="children"
                filterOption={(input, option) =>{
                 return  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || (option.props.children !== '')}
                }
              >
                {/*<Option value={0}>{'全部'}</Option>*/}
                {this.state.shop && this.state.shop.map((item) => {
                  return <Option key={item.shopId} value={item.shopId}>{item.shopName}</Option>
                })}
              </Select>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title='删除分店'
          visible={this.state.showModalDel}
          onOk={this.handleDelOk}
          onCancel={this.handleDelCancel}
          confirmLoading={this.state.confirmLoading}
          okText="确认"
          cancelText="取消"
        >
          <Form layout="horizontal">
            <Form.Item {...formItemLayout} label="需删除的店">
              <Select
                mode="multiple"
                showSearch
                value={_this.state.shopSelectIds}
                style={{width: 240}}
                bordered={true}
                placeholder={'请选择分店'}
                // onSearch={this.onSearchDelShop.bind(this)}
                onChange={this.changeShop}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.props.value == input
                }
              >
                {/*<Option value={0}>{'全部'}</Option>*/}
                {this.state.shop && this.state.shop.map((item) => {
                  return <Option key={item.shopId} value={item.shopId}>{item.shopName}</Option>
                })}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title='输入密码'
          width={'280px'}
          visible={this.state.checkPwdModal}
          onOk={this.oncheckPwdOk.bind(this)}
          onCancel={this.oncheckPwdOkCancel.bind(this)}
          okText="确认"
          cancelText="取消"
        >
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <Input style={{width: '200px'}} type={'password'} placeholder={'请输入密码'} onChange={this.onchangePwd}/>
          </div>
        </Modal>

        <Modal
          title='修改密码'
          width={"300px"}
          visible={this.state.editPwdModal}
          onOk={this.onConfirmPwdOk.bind(this)}
          onCancel={this.onConfirmPwdOkCancel.bind(this)}
          okText="确认"
          cancelText="取消"
        >
          <Input style={{width: "200px"}} type={'password'} placeholder={'请输入原密码'}
                 onChange={(e) => this.setState({oldPwd: e.target.value})}/><br/>
          <Input style={{marginTop: "20px", width: "200px"}} type={'password'} placeholder={'请输入新密码'}
                 onChange={(e) => this.setState({newPwd: e.target.value})}/><br/>
          <Input style={{marginTop: "20px", width: "200px"}} type={'password'} placeholder={'请确认新密码'}
                 onChange={this.confirmPwd.bind(this)}/>

        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/headshop/index.js